import React, { useState, useContext } from 'react';
import axiosConfig from '../../../../../utils/axiosConfig';
// import { Formik, Form, Field } from 'formik';
// import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import { Avatar, CardActions, IconButton, Paper } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import Icon from '@material-ui/core/Icon';
import { StateContext } from '../../../../../context/Provider';

const PostCommentForm = (props) => {

    const appState = useContext(StateContext);
    const { authState } = appState;

    const [comment, setComment] = useState({
        description: ''
    });

    const handleChange = (e) => {
        setComment({description: e.target.value || ''});
    }

    async function createComment() {
        const res = await axiosConfig.post(`/comments`, {
            announcement_id: props.announcementID,
            description: comment.description,
        });

        if (res.data.status_code === 'ok') {
            // globalDispatch({type: 'setSnackbarMsg', value: 'Announcement created successfully.'});
            // globalDispatch({type: 'setIsOpenSnackbar', value: true});
            setComment({description: ''});
            props.fetchAnnouncements();

        } else {
            console.log(res);
        }
    }

    return (
        <CardActions>
            <Paper component="form" className={props.classes.root1} elevation={0} onSubmit={(e) => { createComment(); e.preventDefault(); }}>

                <Avatar aria-label="recipe" className={props.classes.medium} src={authState.user.avatar}>D</Avatar>

                <InputBase
                    className={props.classes.input1}
                    placeholder="Enter your class comment.."
                    // inputProps={{ 'aria-label': 'search google maps' }}
                    onChange={handleChange}
                    value={comment.description}
                />

                <IconButton 
                    type="submit"
                    className={props.classes.iconButton1} 
                    aria-label="submitComment"
                >
                    <Icon>send</Icon>
                </IconButton>

                {/* <Divider className={classes.divider} orientation="vertical" /> */}
            </Paper>
        </CardActions>
    );
}

export default PostCommentForm;